import Vue from "vue";
import { getStations } from "@/data/db";
import StationFilter from "@/domain/filters/stationFilter";

export default {
  namespaced: true,
  state: {
    all: {},
  },
  getters: {},
  mutations: {
    add(state, model) {
      Vue.set(state.all, model.id, model);
    },
  },
  actions: {
    all({ commit }, all = []) {
      for (let model of all) {
        commit("add", model);
      }
    },
    getAll({ dispatch }, { stationFilter = new StationFilter() } = {}) {
      return new Promise((resolve) => {
        const list = getStations(stationFilter);
        dispatch("all", list);
        resolve(list);
      });
    },
  },
};
